export const cortexEndpoint = () => getOrCrash('CORTEX_ENDPOINT');
export const peopleEndpoint = () => getOrCrash('PEOPLE_ENDPOINT');
export const authEndpoint = () => getOrCrash('AUTH_ENDPOINT');
export const notificationsEndpoint = () => getOrCrash('NOTIFICATIONS_ENDPOINT');
export const schedulesEndpoint = () => getOrCrash('SCHEDULES_ENDPOINT');
export const timeOffEndpoint = () => getOrCrash('TIME_OFF_ENDPOINT');
export const iwfmApiCachedEndpoint = () =>
  getOrCrash('IWFM_API_CACHED_ENDPOINT');

export const agentStatusStoreEndpoint = () =>
  getOrCrash('AGENT_STATUS_STORE_ENDPOINT');

export const adherenceEndpoint = () => getOrCrash('ADHERENCE_ENDPOINT');

export const e2eFixedToday = () => process.env.E2E_FIXED_TODAY;

export const cortexBrowserEndpoint =
  process.env.NEXT_PUBLIC_CORTEX_ENDPOINT ?? '';

export const schedulesBrowserEndpoint =
  process.env.NEXT_PUBLIC_SCHEDULES_BROWSER_ENDPOINT ?? '';

export const adherenceBrowserEndpoint =
  process.env.NEXT_PUBLIC_ADHERENCE_ENDPOINT ?? '';

function getOrCrash(key: string) {
  const result = process.env[key];
  if (!result) throw new Error(`${key} environment variable missing`);
  return result;
}
